<mat-dialog-content *ngIf="post">

    <div class="flex-row flex-space-between w-100 pt-10">
        <div class="flex-row gap-15 pl-10">
            <div *ngIf="post?.author && post?.author.id > 0 else anonymous">
                <div [matMenuTriggerFor]="menu" class="moderator clickable"
                     (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false">
                    <app-online-status-badge [isStaff]="post.author?.is_staff"
                                             [userId]="post.author.id"></app-online-status-badge>
                </div>
                <div [appUserAvatar]="post.author" [matMenuTriggerFor]="menu" class="miniInitial clickable"
                     [class.onlineIndicatorOffset]="!community?.disable_online_icon_next_to_profile_picture || post.author?.is_staff"
                     (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false"
                     mat-card-avatar>
                    {{ post.author.username | slice: 0 : 1 | titlecase }}
                </div>
                <mat-menu #menu="matMenu" class="userDisplayMenu">
                    <ng-container *ngIf="userInfoMenuOpen">
                        <app-user-info [user]="post.author"></app-user-info>
                    </ng-container>
                </mat-menu>
            </div>
            <div class="flex-col">
                <mat-card-title>{{ post.title }}</mat-card-title>
                <mat-card-subtitle>{{ post.created_at | relativeTime }}</mat-card-subtitle>
            </div>
        </div>
        <div class="w-100 d-flex justify-content-end p-fixed closBtnHolder">
            <div class="closeBtn">
                <button class="mat-dialog-close" (click)="exitCheck()" mat-mini-fab matTooltip="Close post"
                        tabindex="-1">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
    </div>
    <mat-card-content>
        <app-post-content [content]="post" [disableOverlay]="true"></app-post-content>
        <app-poll-view
                *ngIf="poll && poll.id"
                [forceShowResults]="hasCommunityRole(['client', 'reports_only', 'full_admin', 'observer'])"
                [pollId]="poll.id"></app-poll-view>

    </mat-card-content>
    <ng-container [ngTemplateOutlet]="commentInput"
                  *ngIf="!this.selectedCommunity?.comment_box_at_bottom"></ng-container>
    <div class="flex-row gap-5 align-items-center">
        Sort comments:
        <button [matMenuTriggerFor]="commentsSort" mat-button>
            <mat-icon>{{ selectedSortOption.icon }}</mat-icon>
            {{ selectedSortOption.label }}
        </button>
    </div>

    <app-comments-list class="fixMentionOverflow" [comments]="commentsTree" [post]="post"></app-comments-list>
    <ng-container [ngTemplateOutlet]="commentInput"
                  *ngIf="this.selectedCommunity?.comment_box_at_bottom"></ng-container>
</mat-dialog-content>

<mat-menu #commentsSort="matMenu">
    <button (click)="sortComments(sortOption)" *ngFor="let sortOption of sortOptions" mat-menu-item>
        {{ sortOption.label }}
    </button>
</mat-menu>

<ng-template #anonymous>
    <div class="miniInitial" mat-card-avatar matTooltip="This post was posted anonymously">A
    </div>
</ng-template>
<ng-template #commentInput>
    <app-reply-field (action)="updateComment($event)"
                     *ngIf="!post.comments_off && (isSuperuser || hasCommunityRole(['member', 'client', 'full_admin']))"
                     [post]="post"></app-reply-field>
</ng-template>
